/**
 * 基本校正の Fish 見積り／セッション支払いから、今回の想定課金額を求める。
 *
 * backend のルール:
 * - 必要額 ≤ sessionUsedFish → 無料
 * - 必要額 > sessionUsedFish → 差額のみ
 * - セッションなし → 全額
 */
export function calcExpectedProofreadingCharge(params: {
  estimatedFish: number | null | undefined;
  sessionUsedFish: number | null | undefined;
}): {
  /** 今回 subCoin されうる額（無料なら 0） */
  chargeFish: number;
  /** 支払い済みティア内で無料か */
  isFree: boolean;
  /** 段階制の必要額（上限超過などで不明なら null） */
  requiredFish: number | null;
} {
  const required =
    typeof params.estimatedFish === "number" && Number.isFinite(params.estimatedFish)
      ? params.estimatedFish
      : null;
  if (required == null) {
    return { chargeFish: 0, isFree: false, requiredFish: null };
  }
  const paid =
    typeof params.sessionUsedFish === "number" && Number.isFinite(params.sessionUsedFish)
      ? Math.max(0, params.sessionUsedFish)
      : 0;
  if (required <= paid) {
    return { chargeFish: 0, isFree: true, requiredFish: required };
  }
  return { chargeFish: required - paid, isFree: false, requiredFish: required };
}
